import type { Carer } from '@lmc/ts-common'
import {
  CapabilityKey,
  getCapabilityKeyForPermissionId
} from '../../../components/generic/teamCapabilities'
import type { WizardRole } from '../../../components/generic/teamCapabilities/types'
import type { EditPermissionsData } from '../components/teamList/types'
import { getEffectivePermissions } from './effectivePermissions'

// Reverse-map a carer's *effective* permissions into the side panel's editable
// state. Effective = the carer's own `permissions` plus anything implicitly
// granted by a legacy `permissionsTemplate` (the Care Management bundle) — the
// same calc the team-list chips use — so a bundle Senior Carer's toggles display
// On, matching their row. (`getEffectivePermissions` already returns stringified
// ObjectIds.) Such a carer is converted off the bundle on save — see
// buildUpdatePayload. Unknown ids (permissions the toggles don't manage) are
// ignored.
export const buildInitialData = (carer: Carer): EditPermissionsData => {
  const capabilities: EditPermissionsData['capabilities'] = {}

  for (const id of getEffectivePermissions(carer)) {
    const key = getCapabilityKeyForPermissionId(id)
    if (key) {
      capabilities[key] = true
    }
  }

  capabilities[CapabilityKey.MedicationManagement] = Boolean(
    carer.medicationPermission
  )

  return {
    role: carer.role as WizardRole,
    capabilities
  }
}
